import axios from 'axios';
import restAxios from './rest-axios';
import cookies from 'js-cookie';

const getAll = (data) => restAxios.get(`/manage/cw_zcdj_fkd`, data);
const getDetail = (id) => restAxios.get(`/manage/cw_zcdj_fkd/${id}`);
const postAdd = ({huhao, zhanghao, kaihuhang, sub_title, ids}) => restAxios.post(`/manage/cw_zcdj_fkd`, {huhao, zhanghao, kaihuhang, sub_title, ids});
const postRemove = (id) => restAxios.delete(`/manage/cw_zcdj_fkd/${id}`);
const updatefkrq = (ids, fkrq) => restAxios.post(`/manage/cw_zcdj_fkd/updatefkrq`, {ids, fkrq});

const getwfl = (month) => restAxios.get(`/manage/cw_zcdj_fkd/wfl`, {month});
const getyfl = (month, md) => restAxios.get(`/manage/cw_zcdj_fkd/yfl`, {month, md});
const postadd = (ids, coa_id, md) => restAxios.post(`/manage/cw_zcdj_fkd/add`, {ids, coa_id, md});
const postremove = (ids) => restAxios.post(`/manage/cw_zcdj_fkd/remove`, {ids});

const getcwzcdjstat = (month, coa_name) => restAxios.get(`/manage/cw_zcdj_fkd/stat`, {month, coa_name});
const getcwzcdjstatyue = (year, coa_name) => restAxios.get(`/manage/cw_zcdj_fkd/statyue`, {year, coa_name});

// 获取图片数据（通过代理接口）
const getImageProxy = (url) => {
    const baseURL = window.location.host.indexOf('localhost') > -1 ? "http://localhost:6003/api" : `${window.location.protocol}//${window.location.host}/api`;
    return axios({
        method: 'GET',
        url: `${baseURL}/manage/image/proxy`,
        headers: {authorization: cookies.get('authorization')},
        params: { url },
        responseType: 'blob'
    });
};


export {
    getAll,
    getDetail,
    postAdd,
    postRemove,
    updatefkrq,
    getwfl,
    getyfl,
    postadd,
    postremove,
    getcwzcdjstat,
    getcwzcdjstatyue,
    getImageProxy,
};
